<!-- Navbar -->
<nav class="main-header navbar navbar-expand navbar-white">
  <!-- Left navbar links -->
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" data-widget="pushmenu" [routerLink]=""><i class="fas fa-bars fidelis"></i></a>
    </li>
  </ul>

  <a [routerLink]="" class="navbar-brand">
    <span class="brand-text font-weight-light fidelis"></span>
  </a>

  <span class="brand-text font-weight-light fidelis">{{descripcionSistema}}</span>

  <!-- Right navbar links -->
  <ul class="navbar-nav ml-auto">
    <li class="nav-item dropdown user-menu">
      <a [routerLink]="" class="nav-link dropdown-toggle fidelis" data-toggle="dropdown"
        aria-expanded="true">
        <img src="assets/img/male.png" class="user-image img-circle elevation-2" alt="Usuario">
        <span class="d-none d-md-inline fidelis">{{usuario.usuario}}</span>
      </a>
      <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px;">
        <li class="user-header fidelis-bg">
          <img src="assets/img/user.png" class="img-circle elevation-2" alt="Usuario">
          <p>
            {{usuario.usuario}}
            <small>{{usuario.rol}}</small>
          </p>
        </li>

        <!-- <li class="user-body">
          <div class="row">
            <div class="col-4 text-center">
              <a href="#">Followers</a>
            </div>
            <div class="col-4 text-center">
              <a href="#">Sales</a>
            </div>
            <div class="col-4 text-center">
              <a href="#">Friends</a>
            </div>
          </div>
        </li> -->

        <li class="user-footer">
          <a [routerLink]="" class="btn btn-default btn-flat" (click)="cerrarSesion()">Salir</a>
          <a [routerLink]="" class="btn btn-default btn-flat float-right" (click)="cambiarContrasenia()">Cambiar Contraseña</a>
        </li>
      </ul>
    </li>
  </ul>
</nav>
<!-- /.navbar -->